// /*!
//  * Copyright (c) Microsoft Corporation. All rights reserved.
//  * Licensed under the MIT License.
//  */

// import * as microsoftTeams from "@microsoft/teams-js";
// import { useEffect } from "react";
// import liznrLogo from '../../Images/Liznr-final.png'
// import { Typography } from "@mui/material";
// import '../../AuthPages/login.css'
// // import { getFlexColumnStyles } from "../styles/layouts";
// // import { mergeClasses, Title2, Subtitle2 } from "@fluentui/react-components";

// const TabConfig = () => {
//   useEffect(() => {
//     microsoftTeams.app.initialize()
//       .then(() => {
//         // Notify Teams that the iframe has loaded successfully (must be called within 30s)
//         try { microsoftTeams.app.notifySuccess(); } catch (e) { console.warn("notifySuccess failed", e); }

//         microsoftTeams.pages.config.registerOnSaveHandler(function (saveEvent) {
//           microsoftTeams.pages.config.setConfig({
//             suggestedDisplayName: "Liznr",
//             contentUrl: `${window.location.origin}/CreateRoom?v=2`,
//           });
//           // notify that configuration was saved successfully
//           saveEvent.notifySuccess();
//         });

//         microsoftTeams.pages.config.setValidityState(true);
//       })
//       .catch(err => {
//         console.error("Teams init failed", err);
//         // If initialization fails, notify failure so Teams doesn't just hang
//         try { microsoftTeams.app.notifyFailure({ message: "Initialization failed" }); } catch (_) {}
//       });
//   }, []);

// //   const flexColumnStyles = getFlexColumnStyles();
//   return (
//     <div
//     //   className={}
//     style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",height:"400px"}}
//     >
//      <img src={liznrLogo} alt="LiznrLogo" />
//      <Typography variant="caption" className='text-black text-md fw-medium' sx={{fontSize: '14px' }}>Your Smart <span className='register-link'>AI</span> Assistant</Typography> 
//     </div>
//   );
// };

// export default TabConfig;


import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect } from "react";
import liznrLogo from '../../Images/Liznr-final.png';
import { Typography } from "@mui/material";
import '../../AuthPages/login.css';

const TabConfig = () => {
  // Make sure this env var contains a full URL like "http://localhost:8001" or "https://api.example.com"
  const auth_backend = process.env.REACT_APP_PORT_8001;

  useEffect(() => {
    let isMounted = true;

    const initAndAuth = async () => {
      try {
        await microsoftTeams.app.initialize();
        

        const clientSideToken = await getClientSideToken();
        

        const serverProfile = await getServerSideToken(clientSideToken);
        

        // handle token/profile (rename to avoid 'use' prefix)
        handleServerSideToken(serverProfile);
      } catch (err) {
        console.error("Authentication flow failed:", err);
        try { microsoftTeams.app.notifyFailure({ message: "Authentication failed" }); } catch (_) {}
      }
    };

    initAndAuth();

    return () => { isMounted = false; };
  }, [auth_backend]);

  // ------------------------
  // Functions (renamed so linter doesn't think they're hooks)
  // ------------------------

  function getClientSideToken() {
    return microsoftTeams.authentication.getAuthToken()
      .then(token => token)
      .catch(error => {
        throw new Error("Error getting Teams client-side token: " + error);
      });
  }

  async function getServerSideToken(clientSideToken) {
    if (!auth_backend) throw new Error("Missing auth backend URL in REACT_APP_PORT_8001");

    try {
      const res = await fetch(`${auth_backend}/ms-token/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: clientSideToken })
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Server returned ${res.status}: ${text}`);
      }

      const data = await res.json();
      if (!data || !data.access_token) throw new Error("Invalid server-side token");
      return data;
    } catch (err) {
      throw new Error("Error exchanging token on server: " + err.message);
    }
  }

  function handleServerSideToken(profile) {
   

    // Step 3: Configure the Teams tab
    microsoftTeams.pages.config.registerOnSaveHandler(saveEvent => {
      microsoftTeams.pages.config.setConfig({
        suggestedDisplayName: "Liznr",
        contentUrl: `${window.location.origin}/?v=2`,
      });
      saveEvent.notifySuccess();
    });

    microsoftTeams.pages.config.setValidityState(true);

    // Notify Teams iframe loaded successfully
    try { microsoftTeams.app.notifySuccess(); } catch (e) { console.warn("notifySuccess failed", e); }
  }

  // ------------------------
  // JSX
  // ------------------------

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "400px" }}>
      <img src={liznrLogo} alt="LiznrLogo" />
      <Typography variant="caption" className='text-black text-md fw-medium' sx={{ fontSize: '14px' }}>
        Your Smart <span className='register-link'>AI</span> Assistant
      </Typography>
    </div>
  );
};

export default TabConfig;

